var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeGoec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9932 37.1846C32.5602 35.2374 35.1551 33.2036 36.7621 30.4108C38.4385 27.4974 39.3789 24.1039 39.3789 20.4814C39.3789 9.63365 30.6485 0.839844 19.8789 0.839844C9.10935 0.839844 0.378906 9.63365 0.378906 20.4814C0.378906 25.8493 2.44384 30.7144 5.90876 34.2597L18.1388 43.9174C18.8155 45.005 20.3834 45.0199 21.0804 43.9454L29.9932 37.1846Z",
    fill: "#E37A2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8785,
    cy: 20.022,
    r: 16.9634,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2068 22.0967L29.6232 17.0942C30.881 21.2172 29.3757 25.8349 25.616 28.3637C21.0109 31.4696 14.7562 30.2533 11.6494 25.6425C8.5427 21.0385 9.76615 14.7853 14.3713 11.6793C17.7186 9.42547 21.9319 9.44608 25.1692 11.3976L29.8706 8.22978C24.75 3.9419 17.2168 3.35094 11.402 7.26775C4.36371 12.0229 2.50105 21.5814 7.25051 28.6179C12 35.6613 21.5539 37.5167 28.5922 32.7753C34.7988 28.5904 36.9845 20.6812 34.1595 14.0363C33.7815 13.143 33.3141 12.2703 32.7505 11.432C32.3106 10.7792 31.8364 10.1745 31.314 9.61787L19.2719 17.7401C18.0691 18.551 17.753 20.1864 18.564 21.389C19.375 22.5846 21.004 22.9076 22.2068 22.0967Z",
    fill: "#E37A2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5712 18.5003L20.4344 24.2321C20.4825 24.3077 20.5856 24.3214 20.6544 24.2733L23.7615 22.1772C23.8371 22.1291 23.8509 22.026 23.8028 21.9572L19.9395 16.2256C19.8914 16.1499 19.7882 16.1362 19.7195 16.1843L16.6124 18.2804C16.5437 18.3285 16.523 18.4248 16.5712 18.5003Z",
    fill: "#E37A2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9559 21.4886C15.0864 21.6811 15.3542 21.7361 15.5465 21.6055L17.8749 20.0312C18.0672 19.9006 18.1222 19.6325 17.9916 19.44C17.8612 19.2475 17.5933 19.1925 17.401 19.3232L15.0726 20.8974C14.8803 21.028 14.8254 21.2892 14.9559 21.4886Z",
    fill: "#E37A2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1588 22.2425C17.2893 22.435 17.557 22.49 17.7492 22.3594L20.0762 20.7851C20.2684 20.6545 20.3233 20.3864 20.1929 20.1939C20.0624 20.0014 19.7947 19.9464 19.6025 20.0771L17.2755 21.6513C17.0764 21.7819 17.0284 22.0431 17.1588 22.2425Z",
    fill: "#E37A2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0536 24.6077C17.1845 24.8002 17.4532 24.8552 17.6461 24.7246L19.9818 23.1504C20.1747 23.0197 20.2298 22.7517 20.0989 22.5592C19.968 22.3667 19.6993 22.3117 19.5064 22.4423L17.1707 24.0165C16.971 24.1472 16.9227 24.4084 17.0536 24.6077Z",
    fill: "#E37A2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4415 18.8867L19.7957 19.5943L20.1263 20.1164L18.6045 20.7347L21.0215 20.453L20.6772 19.9309L22.0061 19.7661L21.4415 18.8867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeGoec);
export default __webpack_public_path__ + "static/media/orangeGoec.bb544c9d047fd7c9cbcd21ade878e94c.svg";
export { ForwardRef as ReactComponent };